/** Base path for v2 UI when mounted under the root React Router (no Router basename). */
export const APP_BASE = '/v2'

/** Build an absolute app URL under `/v2`. */
export function appPath(relativePath: string): string {
	const p = relativePath.startsWith('/') ? relativePath : `/${relativePath}`
	return `${APP_BASE}${p}`
}
